import _some from 'lodash/some';
import _without from 'lodash/without';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { SPECIAL_FOLDER_ID_MY_VIDEOS } from 'constants/folders';
import { FOLDER } from 'constants/videosDashboard';
import { fetchFolderHierarchyCreator } from 'creators/videosDashboard';

import Spinner from 'components/ui-components/circular-loading-spinner';
import GridCell from 'components/videos-dashboard/hierarchy-grid/grid-cell';

import './styles.less';

const HierarchyGrid = class extends Component {
  state = {
    opened_folder_ids: [],
  };

  render() {
    const {
      checkedItems,
      currentFolderId,
      foldersHierarchy,
      isFetchingHierarchy,
    } = this.props;

    let gridCells = null;
    let spinner = null;
    let topLevelCell = null;

    if (
      !isFetchingHierarchy &&
      foldersHierarchy.length > 0 &&
      foldersHierarchy[0] &&
      foldersHierarchy[0].children.length > 0
    ) {
      const children = foldersHierarchy[0].children;
      const checkedFolderIds = checkedItems
        .filter(item => item.type === FOLDER)
        .map(item => item.id);

      if (currentFolderId !== SPECIAL_FOLDER_ID_MY_VIDEOS) {
        topLevelCell = this.generateChildren(
          [foldersHierarchy[0]],
          checkedFolderIds,
          1,
          true
        );
      }

      gridCells = this.generateChildren(children, checkedFolderIds, 1, false);
    }

    if (isFetchingHierarchy) {
      spinner = <Spinner />;
    }

    return (
      <div className={`hierarchy-grid ${isFetchingHierarchy ? 'loading' : ''}`}>
        {spinner}
        {topLevelCell}
        {gridCells}
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    this.props.fetchFolderHierarchy();
  }

  closeFolder = (e, id) => {
    e.stopPropagation();

    const { opened_folder_ids: openedFolderIds } = this.state;

    this.setState({ opened_folder_ids: _without(openedFolderIds, id) });
  };

  generateChildren = (folders, checkedFolderIds, level, doNotRecurse) => {
    const { opened_folder_ids: openedFolderIds } = this.state;

    return folders
      .map(folder => {
        return (
          <GridCell
            closeFolder={this.closeFolder}
            checkedFolderIds={checkedFolderIds}
            doNotRecurse={doNotRecurse}
            folder={folder}
            generateChildren={this.generateChildren}
            key={folder.folder.id || folder.folder.local_id}
            level={level}
            openedFolderIds={openedFolderIds}
            openFolder={this.openFolder}
          />
        );
      })
      .filter(folder => folder);
  };

  openFolder = (e, id) => {
    e.stopPropagation();

    const { opened_folder_ids: openedFolderIds } = this.state;

    if (_some(openedFolderIds, id)) {
      return;
    }

    this.setState({ opened_folder_ids: openedFolderIds.concat(id) });
  };
};

const mapStateToProps = state => {
  const {
    checked_items: checkedItems,
    folder_id: currentFolderId,
    folders_hierarchy: foldersHierarchy,
    is_fetching_hierarchy: isFetchingHierarchy,
  } = state.videos_dashboard;

  return {
    checkedItems,
    currentFolderId,
    foldersHierarchy,
    isFetchingHierarchy,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFolderHierarchy: () => dispatch(fetchFolderHierarchyCreator()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyGrid);
